const BASE_URL = "https://redo.local";
export const SETTINGS_SEARCH_QUERY_PARAM = "settingsSearch";
const MIN_PREFIX_TOKEN_LENGTH = 3;

export function getSettingsSearchHref({
  href,
  search,
}: {
  href: string;
  search: string;
}): string {
  const url = new URL(href, BASE_URL);
  if (search.trim()) {
    url.searchParams.set(SETTINGS_SEARCH_QUERY_PARAM, search);
  } else {
    url.searchParams.delete(SETTINGS_SEARCH_QUERY_PARAM);
  }

  return toHref(url);
}

export function getSettingsTabHref({
  href,
  param = "tab",
  tab,
}: {
  href: string;
  param?: string;
  tab: string;
}): string {
  const url = new URL(href, BASE_URL);
  url.searchParams.set(param, tab);
  return toHref(url);
}

export function settingsSearchTextMatches({
  search,
  text,
}: {
  search: string;
  text: string;
}): boolean {
  const queryTokens = getSearchTokens(search);
  if (queryTokens.length === 0) {
    return true;
  }

  const textTokens = getSearchTokens(text);
  return textTokens.some((_, startIndex) =>
    queryTokens.every((queryToken, queryIndex) =>
      searchTokenMatches({
        queryToken,
        textToken: textTokens[startIndex + queryIndex],
      }),
    ),
  );
}

export function normalizeSettingsSearchPhrase(value: string): string {
  return getSearchTokens(value).join(" ");
}

function searchTokenMatches({
  queryToken,
  textToken,
}: {
  queryToken: string;
  textToken: string | undefined;
}): boolean {
  return (
    textToken === queryToken ||
    (queryToken.length >= MIN_PREFIX_TOKEN_LENGTH &&
      textToken?.startsWith(queryToken) === true)
  );
}

function getSearchTokens(value: string): string[] {
  return value
    .toLowerCase()
    .split(/[^a-z0-9]+/)
    .map((token) =>
      token.length > 3 && token.endsWith("s") ? token.slice(0, -1) : token,
    )
    .filter((token) => token.length > 0 && token !== "and");
}

function toHref(url: URL): string {
  if (url.origin === BASE_URL) {
    return `${url.pathname}${url.search}${url.hash}`;
  }

  return url.toString();
}
